<div class="col px-lg-5 px-2">
	<app-nav-gestion-donnees
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
		[isExportable]="isExportable"
		(exportingEvent)="exportBeneficiaires()"
	></app-nav-gestion-donnees>

	<input hidden type="file" #uploader (change)="importBeneficiaires($event)" />

	<div class="row my-3">
		<div class="row">
			<div class="col-auto">
				<button
					class="btn theme-main-color-button"
					(click)="importFromOcashe()"
				>
					<i class="bi bi-cloud-download" aria-hidden="true"></i> Importer
					depuis OCASHE
				</button>
			</div>
			<div class="col-2 ms-lg-auto">
				<div class="dropdown" *ngIf="isSESSAD || isSAE">
					<a
						class="btn btn-secondary dropdown-toggle"
						role="button"
						id="dropdownFilter"
						data-bs-toggle="dropdown"
						data-bs-auto-close="outside"
						aria-expanded="false"
					>
						<i class="bi bi-filter" aria-hidden="true"></i> Filtres
					</a>
					<div class="dropdown-menu px-3 py-3" aria-labelledby="dropdownFilter">
						<div class="row" *ngIf="isSESSAD">
							<span class="theme-main-color form-label">Compétence(s):</span>
							<div class="mb-1">
								<div
									*ngFor="let competence of competences"
									class="form-check ms-3"
								>
									<input
										(change)="changeCompetencesFilter($event, competence.name)"
										class="form-check-input"
										type="checkbox"
										value="{{ competence.name }}"
										id="dd{{ competence.name }}"
									/>
									<label class="form-check-label" for="dd{{ competence.name }}">
										{{ competence.name.replaceAll('_', ' ') }}
									</label>
								</div>
							</div>

							<div class="row d-flex flex-row-reverse">
								<button
									class="btn theme-green-button w-50"
									(click)="filterListByCompetences()"
								>
									Filtrer
								</button>
							</div>
						</div>
						<div class="row" *ngIf="isSAE">
							<span class="theme-main-color form-label">Service(s):</span>
							<div class="mb-1">
								<div
									*ngFor="let department of centerDepartments"
									class="form-check ms-3"
								>
									<input
										(change)="changeDepartmentFilter($event, department)"
										class="form-check-input"
										type="checkbox"
										value="{{ department.name }}"
										id="dd{{ department.name }}"
									/>
									<label class="form-check-label text-dark">
										{{ department.name }}
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-4 col-12 ps-lg-5">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Nom(s), prénom(s), adresse"
						[(ngModel)]="searchedInput"
						(keyup)="onKeyUp()"
					/>
				</div>
			</div>
		</div>
		<div *ngIf="!isMobile" class="row mt-3">
			<div class="col-3">
				<span class="hand-cursor fw-bold" (click)="sortChange('lastName')"
					>Nom
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'lastName' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2" *ngIf="isSESSAD">
				<span class="hand-cursor fw-bold" (click)="sortChange('careSkill.name')"
					>Compétence
					<span
						*ngIf="sortType === 'careSkill.name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'careSkill.name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div *ngIf="isAreaActive" class="col-2">
				<span class="ps-1 hand-cursor fw-bold" (click)="sortChange('area.name')"
					>Secteur
					<span
						*ngIf="sortType === 'area.name' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'area.name' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
			<div class="col-2">
				<span
					class="hand-cursor fw-bold"
					(click)="sortChange('beneficiaire.centerDepartments')"
				>
					Service(s)
					<span
						*ngIf="
							sortType === 'beneficiaire.centerDepartments' &&
							sortOrder === 'asc'
						"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="
							sortType === 'beneficiaire.centerDepartments' &&
							sortOrder === 'desc'
						"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>

			<div class="col">
				<span
					class="ps-1 hand-cursor fw-bold"
					(click)="sortChange('address.label')"
					>Adresse
					<span
						*ngIf="sortType === 'address.label' && sortOrder === 'asc'"
						class="bi bi-caret-up-fill"
					></span>
					<span
						*ngIf="sortType === 'address.label' && sortOrder === 'desc'"
						class="bi bi-caret-down-fill"
					></span>
				</span>
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="mt-4">
			<div
				*ngFor="
					let beneficiaire of beneficiaires
						| filterBeneficiaireByDepartment : selectedDepartments
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage,
									totalItems: totalItems
							  }
						| orderBy : sortType : sortOrder
				"
				class="row my-1 pt-3 pb-1 rounded rounded-3 bg-light"
			>
				<span class="col-lg-3 col-12">
					<span *ngIf="isMobile" class="fw-bold">Nom :</span>
					{{ beneficiaire?.firstName + ' ' + beneficiaire?.lastName }}
				</span>
				<span class="col-lg-2 col-12" *ngIf="isSESSAD">
					<span
						*ngFor="let careSkill of beneficiaire?.careSkills; let ilast = last"
						class="me-1"
					>
						<span *ngIf="isMobile" class="fw-bold">Compétence :</span>
						{{ careSkill.name }}</span
					>
				</span>
				<div *ngIf="isAreaActive" class="col-2">
					<div class="d-flex">
						<span *ngIf="beneficiaire.area" class="flex-grow-1">
							<span *ngIf="isMobile" class="fw-bold">Secteur :</span>
							{{ beneficiaire?.area?.name }}
						</span>
						<span *ngIf="!beneficiaire.area" class="flex-grow-1">
							<span *ngIf="isMobile" class="fw-bold">Secteur :</span>
							<span style="font-style: italic"> Non-renseigné </span>
						</span>
					</div>
				</div>
				<div class="col-lg-2 col-2">
					<span *ngIf="isMobile" class="fw-bold">Service(s) : </span>
					<span *ngIf="beneficiaire.centerDepartments">
						<span
							*ngFor="
								let department of beneficiaire.centerDepartments;
								last as isLast
							"
						>
							<span>{{ department.name }} <span *ngIf="!isLast">- </span></span>
						</span>
					</span>
					<span
						style="font-style: italic"
						*ngIf="beneficiaire.centerDepartments.length === 0"
						>Non-renseigné</span
					>
				</div>
				<div class="col">
					<div class="d-flex">
						<span class="flex-grow-1">
							<span *ngIf="isMobile" class="fw-bold">Adresse :</span>
							{{ beneficiaire?.address?.label }}
						</span>
						<i
							[routerLink]="['/gestion/beneficiaires', beneficiaire.id]"
							role="button"
							class="fs-4 bi bi-caret-right-fill mb-1"
							aria-hidden="true"
						></i>
					</div>
				</div>
			</div>
		</div>
		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="pageHasChanged($event)"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
		</div>
	</div>
</div>
